module.exports = __webpack_public_path__ + "static/saving-lives-90f40316fc75a33f539b0148ba782efb.svg";